import { Buffer } from 'buffer';
import axios from 'axios';

Buffer.from('anything','base64');

const pdwebserver_uri = process.env.REACT_APP_PD_WEB_SERVER
  ? process.env.REACT_APP_PD_WEB_SERVER
  : window.location.origin + '/pdwebserver/';

console.log('webapi_uri: ' + pdwebserver_uri);

const server = axios.create({
  baseURL: pdwebserver_uri,
});

const axiosConfig = {
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
};

export const prokey_server = {
  activeCheck,
  cancelTask,
  clearTask,
  finishTask,
  getDoctypes,
  getTaskQueueInfo,
  addRoleModule,
  removeRoleModule,
  addUserRoles,
  addUserRole,
  removeUserRole,
  getAllRoles,
  getAllUsers,
  getAllModules,
  getAllUserRoles,
  getAllRoleModules,
  getUserRoles,
  getRoleModules,
  getUserDetails,
  getVersion,
  login,
  logout,
  sendLog,
  getRequestAccess,
  postRequestAccess,
  isPasswordResetEnabled,
  resetPassword,
  requestPasswordReset,
  updateField,
  updateFields,
  addUser,
  addBulkUsers,
  addRole,
  removeRoles,
  addModule,
  removeModules,
  updateUsers,
  updateUserRoles,
  updateRoleModules,
  getOcrodTest,
  getOcrodProcesses,
  getOcrodBatchList,
  getOcrodBatch,
  postOcrodBatch,
  getReportNames,
  getReport,
  getResourceCpu,
  getResourceMem,
  getSystemStartDateTime,
  getNumberOfTasks,
  getNumberOfUsersLoggedIn,
  getNumberOfUsersActivelyKeying,
  getNumberOfThreads,
  getNumberOfConversionsPerThread,
  getNumberOfImagesConvertedByLambda,
  getNumberOfImagesConvertedBySystem,
  getBatchName,
  calcAvailableMemory,
  monitorStart,
  monitorStop,
  monitorStatus,
  getOpenFiles,
  closeFile,
};

function activeCheck() {
  return server.get('/activeCheck', axiosConfig);
}

async function cancelTask(task) {
  const requestData = { message: 'cancel' };

  return server.patch(`/prokey/${task}`, requestData, axiosConfig);
}

async function clearTask(task) {
  const requestData = {};

  return server.post(`/prokey/tasks/${task}/clear`, requestData, axiosConfig);
}

async function finishTask(task) {
  const requestData = { message: 'complete' };

  return server.patch(`/prokey/${task}`, requestData, axiosConfig);
}

async function getDoctypes() {
  return server.get('/prokey/doctypes', axiosConfig);
}

async function getVersion() {
  return server.get('/version', axiosConfig);
}

async function getTaskQueueInfo() {
  return server.get('/prokey/taskQueueInfo', axiosConfig);
}

async function login(username, password) {
  const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
  const requestData = { message: 'login' };
  const config = {
    withCredentials: true,
    headers: {
      Authorization: `Basic ${token}`,
    },
  };

  try {
    const response = await server.post(`/login`, requestData, config);
    const result = {
      status: 200,
      data: response.data,
    };
    return result;
  } catch (error) {
    console.log(error);
    return {
      status: 500,
      data: 'Unexpected error during login.',
    };
  }
}

async function logout() {
  try {
    const response = await server.post(`/logout`, {}, axiosConfig);
    const result = {
      status: response.status,
      data: response.data,
    };
    return result;
  } catch (error) {
    console.log(error);
    return {
      status: 500,
      data: 'Unexpected error during logout.',
    };
  }
}

async function sendLog(text) {
  return server.post('/prokey/sendlog', { text: text });
}

async function getRequestAccess() {
  return server.get('/requestaccess');
}

async function postRequestAccess(reqInfo) {
  return server.post('/requestaccess', reqInfo);
}

async function isPasswordResetEnabled() {
  return server.get('/user/password');
}

export async function resetPassword(reqInfo) {
  return server.put('/user/password', reqInfo);
}

export async function requestPasswordReset( user_id ) {
  return server.get( `/prokey/users/${user_id}/password-reset`, axiosConfig );
}

export async function requestPasswordResetViaEmail( reqInfo ) {
  return server.post('/user/password', reqInfo);
}

async function updateField(task, field) {
  const requestData = {
    message: 'update',
    fieldUpdates: [field],
  };

  return server.patch(`/prokey/${task}`, requestData, axiosConfig);
}

async function updateFields(task, fields) {
  const requestData = {
    message: 'update',
    fieldUpdates: fields,
  };

  return server.patch(`/prokey/${task}`, requestData, axiosConfig);
}

//#region [blue] Users

async function addUser(newUserInfo) {
  return server.post(`/prokey/users`, { newUserInfo }, axiosConfig);
}

async function addBulkUsers(bulkUserData) {
  return server.post(`/prokey/users/bulk`, { bulkUserData }, axiosConfig);
}

async function addRole(newRoleInfo) {
  return server.post('/prokey/roles', { newRoleInfo }, axiosConfig);
}

async function removeRoles(roleId) {
  return server.patch('/prokey/roles', { id: roleId }, axiosConfig);
}

async function addModule(newModuleInfo) {
  return server.post('/prokey/modules', { newModuleInfo }, axiosConfig);
}

async function removeModules(moduleId) {
  return server.patch('/prokey/modules', { id: moduleId }, axiosConfig);
}

async function updateUsers(action, userIds, userData = {}) {
  return server.patch(`/prokey/users`, { action: action, userIds: userIds, userData: userData }, axiosConfig);
}

export async function updateUser( user_id, user_data = {} ) {
  return server.patch( `/prokey/users/${user_id}`, { user_data }, axiosConfig );
}

async function updateUserRoles(userId, roleUpdates) {
  return server.patch(`/prokey/users/${userId}/roles`, { updates: roleUpdates }, axiosConfig);
}

async function updateRoleModules(roleId, moduleUpdates) {
  return server.patch(`/prokey/roles/${roleId}/modules`, { updates: moduleUpdates }, axiosConfig);
}

async function addRoleModule(roleId, moduleId) {
  return server.post(`/prokey/roles/${roleId}/modules`, { module: moduleId }, axiosConfig);
}

async function removeRoleModule(roleId, moduleId) {
  return server.patch(`/prokey/roles/${roleId}/modules`, { module: moduleId }, axiosConfig);
}

async function addUserRoles(userId, roleIds) {
  return server.post(`/prokey/users/${userId}/roles`, { roles: roleIds }, axiosConfig);
}

async function addUserRole(userId, roleId) {
  return server.post(`/prokey/users/${userId}/roles`, { role: roleId }, axiosConfig);
}

async function removeUserRole(userId, roleId) {
  return server.patch(`/prokey/users/${userId}/roles`, { role: roleId }, axiosConfig);
}

async function getAllRoles() {
  return server.get(`/prokey/roles`, axiosConfig);
}

async function getAllUsers(showDisabled = false) {
  const lcl_axiosConfig = {
    ...axiosConfig,
    params: { showDisabled: showDisabled },
  };
  return server.get(`/prokey/users`, lcl_axiosConfig);
}

async function getAllModules() {
  return server.get(`/prokey/modules`, axiosConfig);
}

async function getAllUserRoles() {
  return server.get(`/prokey/users/roles`, axiosConfig);
}

async function getAllRoleModules() {
  return server.get(`/prokey/roles/modules`, axiosConfig);
}

async function getUserRoles(user) {
  return server.get(`/prokey/users/${user}/roles`, axiosConfig);
}

async function getRoleModules(role) {
  return server.get(`/prokey/roles/${role}/modules`, axiosConfig);
}

async function getUserDetails() {
  return server.get(`/userdetail`, axiosConfig);
}

//#endregion

//#region [orange] ocrod
async function getOcrodTest() {
  return server.get(`/api/on-demand/test`, axiosConfig);
}
async function getOcrodProcesses() {
  return server.get(`/api/on-demand/processes`, axiosConfig);
}
async function getOcrodBatchList(startdate) {
  try {
    let config = {...axiosConfig};
    config.params = new URLSearchParams([['startdate', startdate]]);
    return server.get(`/api/on-demand/batches`, config);
  } catch (error) {
    console.warn( error );
  }
}
async function getOcrodBatch(process, batchId) {
  let thisConfig = JSON.parse(JSON.stringify(axiosConfig));
  thisConfig.params = new URLSearchParams([
    ['process', process],
    ['batchId', batchId],
  ]);
  return server.get(`/api/on-demand/batch`, thisConfig);
}
async function postOcrodBatch(process, files, onProgressHandler) {
  let thisConfig = {
    ...axiosConfig,
    onUploadProgress: onProgressHandler,
  };
  return server.post(`/api/on-demand/batch`, { process, files }, thisConfig);
}
//#endregion

async function getReportNames() {
  return server.get(`/statistics/reports`, { withCredentials: true });
}

async function getReport( name, date_start, date_end ) {
  return server.get(`/statistics/reports/${name}?date_start=${date_start}&date_end=${date_end}`, {
    withCredentials: true,
  });
}

async function getSystemStartDateTime() {
  return server.get(`/system/systemStartDateTime`, { withCredentials: true });
}
async function getNumberOfTasks() {
  return server.get(`/system/tasks`, { withCredentials: true });
}
export async function getProkeyTaskMetrics() {
  return server.get(`/prokey/metrics/tasks`, { withCredentials: true });
}

async function getNumberOfUsersLoggedIn() {
  return server.get(`/system/usersLoggedIn`, { withCredentials: true });
}

async function getNumberOfUsersActivelyKeying() {
  return server.get(`/system/usersActivelyKeying`, { withCredentials: true });
}

async function getNumberOfThreads() {
  return server.get(`/system/threads`, { withCredentials: true });
}

async function getNumberOfConversionsPerThread() {
  return server.get(`/system/conversionsPerThread`, { withCredentials: true });
}

async function getNumberOfImagesConvertedByLambda() {
  return server.get(`/system/imagesConvertedByLambda`, { withCredentials: true });
}

async function getNumberOfImagesConvertedBySystem() {
  return server.get(`/system/imagesConvertedBySystem`, { withCredentials: true });
}

async function getBatchName() {
  return server.get(`/system/batchName`, { withCredentials: true });
}

async function calcAvailableMemory() {
  return server.get(`/system/availableMemory`, { withCredentials: true });
}

async function getResourceCpu() {
  return server.get(`/resources/cpu`, { withCredentials: true });
}

async function getResourceMem() {
  return server.get(`/resources/mem`, { withCredentials: true });
}

async function monitorStart() {
  return server.get(`system/monitor/start`, axiosConfig);
}

async function monitorStop() {
  return server.get(`system/monitor/stop`, axiosConfig);
}

async function monitorStatus() {
  return server.get(`system/monitor/status`, axiosConfig);
}

export async function serverRestart() {
  return server.get(`system/restart`, axiosConfig);
}

export async function getOpenFiles() {
  return server.get(`/file-handles`, { withCredentials: true });
}

export async function closeFile(id, path) {
  return server.delete(`/file-handles/${id}?path=${path}`, { withCredentials: true });
}

//#endregion
